const styles = {
  headerSection: {
    position: "relative",
    display: "flex",
    top: "0",
    width: "100vw",
    height: "5em"
  },
  headerIcon: {
    padding: "1em",
    color: "rgb(106, 106, 120)",
    width: "74px",
    height: "74px"
  },
  headerBreadCrumb: {
    color: "rgb(147, 147, 162)",
    fontFamily: "ToyotaType-Semibold",
    fontSize: "24px",
    fontWeight: "600",
    height: "74px",
    letterSpacing: "-0.5px",
    width: "232px",
    padding: "16px 0",
    textAlign: "left"
  },
  body: {
    position: "relative",
    top: "0",
    width: "100vw",
    height: "100vh"
  },
  titleSection: {
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    alignItems: "center",
    marginBottom: ".625em"
  },
  listSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "2em"
  },
  totalSection: {
    display: "flex",
    flexFlow: "row",
    height: "74px",
    justifyContent: "center",
    alignContent: "center"
  },
  totalItems: {
    width: "420px",
    height: "74px",
    display: "flex",
    justifyContent: "center",
    alignContent: "center"
  },
  total: {
    color: "rgb(29, 31, 32)",
    fontFamily: "ToyotaType-Semibold",
    fontWeight: "600",
    letterSpacing: "-0.5px",
    fontSize: "24px",
    width: "50%"
  },
  totalDescription: {
    paddingLeft: "26px",
    textAlign: "left"
  },
  totalAmount: {
    paddingRight: "26px",
    textAlign: "right"
  },
  listItem: {
    padding: "1em",
    width: "420px",
    height: "74px",
    display: "flex",
    justifyContent: "center",
    alignContent: "center"
  },
  listProduct: {
    margin: "auto 1em",
    fontFamily: "ToyotaType-Regular",
    fontWeight: "normal",
    letterSpacing: "-0.5px",
    fontSize: "20px"
  },
  listChip: {
    color: "rgb(255, 255, 255)",
    fontFamily: "ToyotaType-Semibold",
    fontSize: "20px",
    fontWeight: "600",
    height: "28px",
    letterSpacing: "-0.5px",
    textAlign: "center",
    width: "80px",
    margin: "auto 1em",
    backgroundColor: "rgb(106, 106, 120)"
  },
  actionsSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  title: {
    width: "640px",
    height: "57px",
    color: "rgb(29, 31, 32)",
    fontSize: "40px",
    fontFamily: "ToyotaType-Semibold",
    fontWeight: "600",
    textAlign: "center",
    letterSpacing: "-0.5px"
  },
  subTitle: {
    color: "rgb(147, 147, 162)",
    fontFamily: "ToyotaType-Regular",
    fontSize: "24px",
    fontWeight: "normal",
    height: "34px",
    letterSpacing: "-0.5px",
    textAlign: "center",
    width: "480px"
  },
  actions: {
    width: "17.3em",
    height: "3.8em",
    maxWidth: "366px",
    maxHeight: "74px",
    marginBottom: ".7em;",
    background: "rgb(0, 168, 126)",
    borderRadius: 0,
    boxShadow: "none",
    fontFamily: "ToyotaType-Semibold",
    fontSize: "24px",
    fontWeight: "600",
    letterSpacing: "-0.5px"
  },
  actions_link: {
    textDecoration: "none",
    color: "rgb(66, 129, 255)",
    fontFamily: "ToyotaType-Semibold",
    fontSize: "24px",
    fontWeight: "600",
    height: "34px",
    letterSpacing: "-0.5px",
    textAlign: "center",
    width: "269.88px",
    marginTop: ".7em"
  }
};

export default styles;
